module.exports = __webpack_public_path__ + "static/media/IMG_8012.b8882ecd.jpg";